/**
 * External Dependencies
 */
import 'jquery';
import { stickyHeader } from './functions/header';
import { sliderWines, sliderImages } from './functions/sliders';
import { scrollAnchors } from './functions/scroll';

$(document).ready(() => {
  stickyHeader()
  sliderWines()
  sliderImages()
  scrollAnchors()
});
